import { GroupData } from "../types/GroupData";


export const getResultKey = (type: string, num: number) => `songResult${type}${num}`;

export const getNumericResult = (value: any): number => {
  const num = Number(value);
  return isNaN(num) ? 0 : num;
};

// ペナルティがついているかチェック
export const isPenaltyChecked = (
  penaltyKey: string,
  isEditMode: boolean,
  group: GroupData,
  editablePenalties: Record<string, boolean>
): boolean => {
  return isEditMode
    ? editablePenalties[penaltyKey] ?? false
    : !!group[penaltyKey as keyof GroupData];
};

// ペナルティが付いていた場合classNameに"penalty-score"を付与
export const getResultClassName = (
  type: string,
  penaltyKey: string,
  isEditMode: boolean,
  group: GroupData,
  editablePenalties: Record<string, boolean>
): string => {
  const base = type.toLowerCase();
  const isChecked = isPenaltyChecked(
    penaltyKey,
    isEditMode,
    group,
    editablePenalties
  );
  return isChecked ? `${base} penalty-score` : base;
};

// 各項目の平均点を算出
export const getAverageBySongs = (
  group: GroupData,
  editableResults: Record<string, string>,
  isEditMode: boolean,
  songNums: number[],
  types: ("Mus" | "Per" | "Sng")[] = ["Mus", "Per", "Sng"]
): string => {
  let sum = 0;
  let count = 0;

  for (const num of songNums) {
    for (const type of types) {
      const key = getResultKey(type, num);
      const value = isEditMode
        ? editableResults[key]
        : group[key as keyof GroupData];
      const numVal = getNumericResult(value);
      if (!isNaN(numVal)) {
        sum += numVal;
        count++;
      }
    }
  }

  if (count === 0) return "0.0";

  const avg = Math.round((sum / count) * 10) / 10;
  return avg.toFixed(1);
};

// 各項目の合計点を算出
export const getTotalBySongs = (
  group: GroupData,
  editableResults: Record<string, string>,
  isEditMode: boolean,
  songNums: number[]
): number => {
  let sum = 0;

  for (const num of songNums) {
    for (const type of ["Mus", "Per", "Sng"] as const) {
      const key = getResultKey(type, num);
      const value = isEditMode
        ? editableResults[key]
        : group[key as keyof GroupData];
      const numVal = getNumericResult(value);
      if (!isNaN(numVal)) {
        sum += numVal;
      }
    }
  }

  return sum;
};

export const getTypeTotal = (
  group: GroupData,
  type: "Mus" | "Per" | "Sng",
  songNums: number[] = [1, 2, 3, 4]
): number => {
  let sum = 0;
  for (const num of songNums) {
    const key = getResultKey(type, num);
    const value = group[key as keyof GroupData];
    sum += getNumericResult(value);
  }
  return sum;
};

// 合計得点順に並べ替え (総合 → Sng → Per)
export const getSortedGroups = (groups: GroupData[], p0: {}, p1: boolean, p2: number[]): GroupData[] => {
  return [...groups].sort((a, b) => {
    const totalA =
      getTypeTotal(a, "Mus") + getTypeTotal(a, "Per") + getTypeTotal(a, "Sng");
    const totalB =
      getTypeTotal(b, "Mus") + getTypeTotal(b, "Per") + getTypeTotal(b, "Sng");

    if (totalB !== totalA) return totalB - totalA;

    const sngA = getTypeTotal(a, "Sng");
    const sngB = getTypeTotal(b, "Sng");
    if (sngB !== sngA) return sngB - sngA;

    const perA = getTypeTotal(a, "Per");
    const perB = getTypeTotal(b, "Per");
    if (perB !== perA) return perB - perA;

    return 0; // 完全同点
  });
};